module.exports = __webpack_public_path__ + "static/media/event-guy.41a1795f.svg";